// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3IlRN","signatureButtonsRight":"ModalSign_signatureButtonsRight__MBwRQ"};